const values = [
  { label: "Contrato", value: 1 },
  { label: "Judicial", value: 2 },
  { label: "Pre-Judicial", value: 3 },
  { label: "Pago", value: 4 },
  { label: "Otros", value: 5 },
];

export default values;
